import { createRevisionClassResource } from "../../revision";
import { RevisionItem } from "../RevisionItem";
import {
  apiField,
  itemApiField,
  constructFromApiData,
  getApiPostData,
  getDiff,
  decimalApiField,
} from "../ResourceItemMetadata";
import { RodzajKomponentu } from "./RodzajKomponentu";
import { ResourceItem } from "../ResourceItem";
import Decimal from "decimal.js";
import MegaraxClient from "../../megaraxClient";
import { getDumpAction } from "../../dump";

export class Komponent extends RevisionItem {
  @apiField()
  name!: string;

  @itemApiField(RodzajKomponentu)
  rodzaj: RodzajKomponentu | null = null;
  @apiField()
  nazwaHandlowa: string | null = null;
  @apiField()
  kod: string | null = null;
  @decimalApiField({ inputName: "cena", outputName: "cena" })
  price: Decimal = new Decimal(0.0);
  @decimalApiField()
  gestosc: Decimal | null = null;

  @apiField({ readOnly: true })
  activeRecepturaSet: ResourceItem[] | null = null;

  constructor(data: any) {
    super(data);
    if (data) constructFromApiData(this, data);
  }

  getPostData() {
    return {
      ...super.getPostData(),
      ...getApiPostData(this),
    };
  }

  getDiff(other: this) {
    return {
      ...getDiff(this, other),
    };
  }
}

const dataDumpLabelMap = [
  { key: "id", header: "id" },
  { key: "cena", header: "cena" },
  { key: "gestosc", header: "gestosc" },
  { key: "kod", header: "kod" },
  { key: "name", header: "name" },
  { key: "nazwaHandlowa", header: "nazwaHandlowa" },
  { key: "rodzaj", header: "rodzaj" },
];

export const komponentResource = (client: MegaraxClient) => ({
  ...createRevisionClassResource(
    "plm/komponent/",
    Komponent,
    (data) => new Komponent(data),
  )(client),
  dump: getDumpAction("plm/komponent/", dataDumpLabelMap)(client),
});
